import { useMutation, useQueryClient } from '@tanstack/react-query';

import { HttpClientError, IQuerySettings, QueryKeys, getQuerySettings } from '@dw/models/shared';
import { IInitializePortalAuthRequest, IInitializePortalAuthResponse, ISwitchSchoolsRequest } from '@dw/models/auth';
import { useAuth, useHttpClient, useSnackbar } from '@dw/hooks';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@dw/constants';

const BASE_URL = '/v1/auth';

export const useInitializePortalAuthMutation = (settings?: IQuerySettings<IInitializePortalAuthResponse, IInitializePortalAuthRequest>) => {
    const { POST } = useHttpClient();
    const queryClient = useQueryClient();

    const initializeAuth = async (request: IInitializePortalAuthRequest) => {
      return await POST<IInitializePortalAuthResponse>(`${BASE_URL}/initialize-portal`, request);
    }

    const querySettings = getQuerySettings(settings)
    return useMutation<IInitializePortalAuthResponse, HttpClientError, IInitializePortalAuthRequest>({
      ...querySettings,
      mutationFn: initializeAuth,
      onSuccess: (response, input) => {
        queryClient.setQueryData([QueryKeys.Self], response.user);
        if (querySettings.onSuccess) {
          querySettings.onSuccess(response, input)
        }
      }
    })
}

export const useSwitchSchoolsMutation = (settings?: IQuerySettings<IInitializePortalAuthResponse, ISwitchSchoolsRequest>) => {
  const { POST } = useHttpClient();
  const queryClient = useQueryClient();
  const { setAuthDetails } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const switchSchools = async (request: ISwitchSchoolsRequest) => {
    return await POST<IInitializePortalAuthResponse>(`${BASE_URL}/switch-schools`, request);
  }

  const querySettings = getQuerySettings(settings)
  return useMutation<IInitializePortalAuthResponse, HttpClientError, ISwitchSchoolsRequest>({
    ...querySettings,
    mutationFn: switchSchools,
    onSuccess: (response, input) => {
      queryClient.clear();
      
      if (response.danceSchool) {
        queryClient.setQueryData([QueryKeys.DanceSchools, response.danceSchool.id], response);
        showSnackbar(`Successfully switched to ${response.danceSchool.name}`);
      }

      setAuthDetails(response);
      navigate(ROUTES.Dashboard);

      if (querySettings.onSuccess) {
        querySettings.onSuccess(response, input)
      }
    }
  })
}